import colors from './styles/colors/colors';
import spacing from './styles/spacing/spacing';
import buttons from './styles/buttons/buttons';
import links from './styles/links/links';
import typography from './styles/typography/typography';

const stylesConfig = {
  typography: {
    headingVeryLarge: { ...typography.h1 },
    headingSmall: { ...typography.h5 },
    headingVerySmall: { ...typography.h6 },
    headingNotes: { ...typography.h7 },
    veryBoldHeading: { ...typography.veryBoldHeading },
    boldHeading: { ...typography.boldHeading },
    paragraph: { ...typography.p },
    paragraphDescription: { ...typography.pDescription },
    label: { ...typography.label },
    navlink: { ...typography.navlink },
    newLink: { ...typography.newLink },
    buttons: { ...typography.buttons },

    filterItem: { ...typography.filterItem },
    rowItem: { ...typography.rowItem },
  },
  spacing: {
    ...spacing,
  },
  colors,
  tiles: {
    greenTile: '#8CC63F',
    socialTile: '#991b29',
    govTile: '#EE7600',
    oliverTile: '#847D31',
  },
  sizes: {
    distanceFromTopToContent: '52px',
    sizeOfLayoutHeader: '42px',
    bottomMarginOfLayoutHeader: '80px',
    sidebarDistanceFromTop: '200px',
  },
  modalSizes: {
    standard: '800px',
  },
  links,
  shadows: {
    standard: '0px 3px 6px #00000029',
  },
  buttons,
  navigationActive: {
    '& .navigation-link-text': {
      fontWeight: 'bold',
    },
    '& .navigation-link-text::after': {
      content: "' '",
      position: 'absolute',
      left: '0',
      bottom: '10px',
      height: '3px',
      width: '100%',
      background: colors.primary,
      borderRadius: '4px',
      cursor: 'pointer',
    },
  },

  tabStyle: {
    color: colors.black,
    fontSize: 16,
  },
};

export default stylesConfig;
